import { render, staticRenderFns } from "./workorderRelationDialog.vue?vue&type=template&id=127a43dc&scoped=true&"
import script from "./workorderRelationDialog.vue?vue&type=script&lang=js&"
export * from "./workorderRelationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a43dc",
  null
  
)

export default component.exports